module.exports = __webpack_public_path__ + "img/75.e10a534e.jpg";